// Tax return filing status types

const FILING_JOINTLY = 'FILING_JOINTLY';
const FILING_SEPARATELY = 'FILING_SEPARATELY';
const HEAD_OF_HOUSEHOLD = 'HEAD_OF_HOUSEHOLD';
const QUALIFYING_WIDOWER = 'QUALIFYING_WIDOWER';
const SINGLE = 'SINGLE';


// Tax relationships types

const DEPENDENT = 'DEPENDENT';
const FILER_DEPENDENT = 'FILER_DEPENDENT';
const FILER = 'FILER';


// Common type

const UNSPECIFIED = 'UNSPECIFIED';


export const THC_TYPES = {
    HEAD_OF_HOUSEHOLD,
    FILING_JOINTLY,
    FILING_SEPARATELY,
    QUALIFYING_WIDOWER,
    SINGLE,
    FILER,
    FILER_DEPENDENT,
    DEPENDENT,
    UNSPECIFIED
};